module.exports = __webpack_public_path__ + "img/saba-island.92315156.svg";